import React, { FunctionComponent, useEffect } from 'react';
import ReactGA from 'react-ga';
import { observer } from 'mobx-react-lite';
import { GlobalWrapperStyled } from '@styles/global-styles/GlobalWrapperStyled';
import GlobalStyle from '@styles/global-styles';
import CalculationHeight from '@components/CalculationHeight';
import ModalContainer from 'modal-windows/containers/modal-container/ModalContainer';
import Pages from '@pages/Pages';
import './localization';
import { useSentry } from '@hooks/useSentry';

const App: FunctionComponent = (): JSX.Element => {
    useEffect(() => {
        // Initialize Google Analytics
        ReactGA.initialize('G-EMN5T2ZE7R');
    }, []);
    useSentry();

    return (
        <GlobalWrapperStyled>
            <CalculationHeight>
                <GlobalStyle />
                <Pages />
                <ModalContainer />
            </CalculationHeight>
        </GlobalWrapperStyled>
    );
};

export default observer(App);
